import React from "react";
import PropTypes from "prop-types";

import { updateParamFromUrlString } from '@core/components/utility';

/**
 * Used by external component as well - @react/shared-component/PaginationLists/View.jsx
 */
export default function WrapperIconsPage({ icon: Icon, handleFunction, targetPageNum, paginationUrlParam }) {
	const accesbility_objects = {
		aria_label:
			Icon.prototype.constructor.name === "PrevPageIcon"
				? "Previous Page"
				: "Next Page",
	};

	return (
		<a
			href={updateParamFromUrlString(paginationUrlParam, targetPageNum)}
			className="pagination__item text-base"
			onClick={(e) => {
				e.preventDefault();
				handleFunction();
			}}
			type="button"
			role="button"
			rel={Icon.prototype.constructor.name === "PrevPageIcon" ? 'prev' : 'next'}
			aria-label={accesbility_objects.aria_label}
			tabIndex={0}
			onKeyDown={(e) => {
				if (e.code === "Enter") {
					e.preventDefault();
					handleFunction();
				};
			}}
		>
			<Icon />
		</a>
	);
}

WrapperIconsPage.propTypes = {
	icon: PropTypes.func.isRequired,
	handleFunction: PropTypes.func.isRequired,
};
